import React, {useState} from "react";
import './professionalItem.scss';
import { useHistory } from 'react-router-dom';
import {createAnalyticsEvent} from '../../../firebase/firebase';

import {ReactComponent as UserLogo} from '../../../assests/user-avatar.svg';

export default function ProfessionalItem(props) {

    const { professional } = props;
    const {id, businessName, ownerName, category, logoUrl } = professional;

    const [isLogoLoaded, setIsLogoLoaded] = useState(!logoUrl ? true : false);


    const history = useHistory();

    const onProfessionalClicked = ()=>{
        history.push(`/${id}`);
        createAnalyticsEvent({eventName: 'profession-clicked', eventParams: {id, businessName, ownerName, category}});
    }

    const onLogoLoad = ()=>{
        setIsLogoLoaded(true);
    }

    return (
            <div className={'professional-container'} key={`professional-container-${id}`} onClick={onProfessionalClicked}>
                <div className={'professional-container-upper'}>
                    <div className={'professional-container-right'}>
                        <div className={'professional-name'} key={`businessName-${id}`}>{businessName}</div>
                    </div>
                    <div className={'professional-container-left'}>
                        {logoUrl ? <img className={`user-logo-cloud ${isLogoLoaded ? '' : 'loading'}`} src={logoUrl} onLoad={onLogoLoad}/> :
                            <UserLogo className={'user-logo-svg'}/>}

                        <div key={`ownerName-${id}`}>{ownerName}</div>
                    </div>
                </div>
                <div className={'professional-container-category'} key={`category-${id}`}>-{category}-</div>
            </div>

    );
}